import React, { useEffect, useState } from "react";
import Navbar from "../../../components/Navbar/Navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowCircleLeft,
  faArrowLeft,
} from "@fortawesome/fontawesome-free-solid";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Select from "react-select";
import { getBookingDetails } from "../../../redux/booking/booking-slice";
import { setProfileBoxAction } from "../../../redux/auth/auth-slice";

import axios from "axios";
import { toast } from "react-toastify";

const OrderDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const GoogleMApApiKey = process.env.REACT_APP_GOOGLE_API_KEY;

  const { token } = useSelector((state) => state.auth);
  const { bookingDetails } = useSelector((state) => state.booking);
  const { allDrivers } = useSelector((state) => state.driver);
  const [driverid, setdriverid] = useState("");
  const [trackingDetails, setTrackingDetails] = useState({});
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [center, setCenter] = useState({ lat: 49.8584, lng: 2.2945 });
  const [driversForAssign, setdriversForAssign] = useState([]);

  console.log(bookingDetails, "bookingDetails");

  const containerStyle = {
    width: "100%",
    height: "100%",
  };

  const getTracking = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bookings/trackingDetail?generatedBookingId=${id}`
    );

    setTrackingDetails(response?.data);
  };

  const getDriversForAssign = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/drivers/getDriversForAssign`,
        {
          headers: {
            Authorization: token,
          },
          withCredentials: true,
        }
      );

      setdriversForAssign(response?.data?.drivers);
    } catch (error) {
      toast.error(error?.response?.data?.msg);
    }
  };

  useEffect(() => {
    getDriversForAssign();
  }, [token]);

  useEffect(() => {
    getTracking();
  }, []);

  useEffect(() => {
    dispatch(
      getBookingDetails({
        bookingDetails: {},
      })
    );
    if (token) {
      dispatch({
        type: "BOOKING_DETAILS",
        payload: {
          bookingId: id,
          token: token,
        },
      });
    }
  }, [token, dispatch, id]);

  useEffect(() => {
    dispatch(setProfileBoxAction({ profileBoxAction: false }));
  }, []);

  return (
    // deploy
    <div className="  fixed">
      {/* header */}
      <Navbar />

      <div
        className="bg-black py-3"
        onClick={() => {
          dispatch(setProfileBoxAction({ profileBoxAction: false }));
        }}
      >
        {/* <div className="border-b border-white/30 mx-0"></div> */}
        <div className="px-3 md:px-10 2xl:px-32 py-3 w-min text-white">
          <Link
            to="/ordermanage"
            className="bg-slate-900 border border-slate-800 rounded-full p-2"
          >
            <FontAwesomeIcon
              icon={faArrowLeft}
              className="w-5 h-5 text-white/800 cursor-pointer pt-0.5"
            />
          </Link>
        </div>
        <div className="overflow-y-auto h-[90vh] scrollbar px-3 md:px-10 2xl:px-32 py-2">
          {/* Booking Details & passenger details */}
          <div className="cardBorder2 borderFN">
            <div
              id="grad"
              className="h-min rounded-lg shadow-[#0f0e0e] pb-28 lg:pb-2"
            >
              {/* BOOKING DETAILS */}
              <div>
                <div className="sm:flex justify-between rounded-lg bg-gradient-to-r from-[#0c0c0c] via-[#444444] to-[#0c0c0c] px-6 py-2 w-full text-xl font-semibold text-white">
                  <div className="hidden sm:block w-1/2 lg:w-3/5">
                    Booking Details
                  </div>
                  <div className="hidden sm:block w-1/2 lg:w-2/5">
                    Passenger Details
                  </div>
                  <div className="sm:hidden w-1/2 lg:w-3/5">Details</div>
                </div>
                <div className="sm:hidden w-full text-lg font-semibold text-[#00E0FF] px-6 pt-6">
                  <h2>Booking Details</h2>
                </div>
                <div className="sm:flex justify-between">
                  <div className="w-full sm:w-1/2 px-6 py-3 sm:py-6 space-y-2">
                    <BookingDetailsItem
                      label="Booking ID"
                      value={bookingDetails?.bookingId}
                    />
                    <BookingDetailsItem
                      label="Booking Type"
                      value={bookingDetails?.bookingType}
                    />
                    <BookingDetailsItem
                      label="Flight No"
                      value={
                        bookingDetails?.passengerDetails?.flightNumber !==
                        "" ? (
                          bookingDetails?.passengerDetails?.flightNumber
                        ) : (
                          <>
                            <hi className="text-[#fb4156] font-medium">
                              FLIGHT NOT ASSIGNED
                            </hi>
                          </>
                        )
                      }
                    />
                    <BookingDetailsItem
                      label="Booking Status"
                      value={bookingDetails?.bookingStatus}
                    />
                    <BookingDetailsItem
                      label="Price"
                      value={
                        bookingDetails?.purchasePrice +
                        " " +
                        bookingDetails?.purchaseCurrency
                      }
                    />
                    {/* <BookingDetailsItem label="Flight No" value="EK574" /> */}
                  </div>

                  {/* PASSENGER DETAILS */}
                  <div className="w-full sm:w-1/2 lg:w-2/5 px-6 sm:px-0 py-3 sm:py-6 space-y-2">
                    <div className="sm:hidden w-full text-lg font-semibold text-[#00E0FF]">
                      <h2>Passenger Details</h2>
                    </div>
                    <BookingDetailsItem
                      label="Passenger Name"
                      value={
                        bookingDetails?.passengerDetails?.firstName +
                        " " +
                        bookingDetails?.passengerDetails?.lastName
                      }
                    />
                    <BookingDetailsItem
                      label="Contact No"
                      value={
                        bookingDetails?.passengerDetails?.code +
                        " " +
                        bookingDetails?.passengerDetails?.phone
                      }
                    />
                    <BookingDetailsItem
                      label="Passenger Count"
                      value={bookingDetails?.passenger}
                    />
                    <BookingDetailsItem
                      label="Affiliate Note"
                      value={
                        bookingDetails?.affiliateNote
                          ? bookingDetails?.affiliateNote
                          : "--"
                      }
                    />
                  </div>
                </div>
                <Link
                  className="w-min bg-white text-center mx-6 px-5 py-1.5 mb-4  flex text-sm text-slate-700 font-body font-bold rounded-full hover:bg-slate-200 shadow-sm"
                  to={`/tracking/${bookingDetails?.bookingId}`}
                  target="_blank"
                >
                  View&nbsp;Tracking
                </Link>
                {/* Pick up and Drop off details */}
                <div className="lg:flex lg:justify-between">
                  <div className="w-full lg:w-3/5 px-6 py-3">
                    <div className="w-full py-3 text-lg font-semibold text-[#00E0FF] flex items-center space-x-2">
                      <h2>Pick Up & Drop off Details</h2>
                    </div>
                    <div className="pt-2 space-y-2">
                      <BookingDetailsItem
                        label="Pick&nbsp;Up"
                        value={bookingDetails?.source?.placename}
                      />
                      {bookingDetails?.destination?.placename && (
                        <BookingDetailsItem
                          label="Drop&nbsp;Off"
                          value={bookingDetails?.destination?.placename}
                        />
                      )}
                      <BookingDetailsItem
                        label="Pick up Date | Time "
                        value={
                          bookingDetails?.travelDate
                            ? moment(
                                bookingDetails?.travelDate?.split("T")[0]
                              ).format("DD-MM-YYYY") +
                              " | " +
                              bookingDetails?.travelTime
                            : ""
                        }
                      />
                      <BookingDetailsItem
                        label="Duration"
                        value={
                          bookingDetails?.durationForAffiliate
                            ? bookingDetails?.durationForAffiliate
                            : "--"
                        }
                      />
                      {bookingDetails?.passengerDetails?.specialRequest && (
                        <BookingDetailsItem
                          label="Special Request"
                          value={
                            bookingDetails?.passengerDetails?.specialRequest
                          }
                        />
                      )}
                    </div>
                  </div>
                  <div className="w-full lg:w-2/5 py-3 space-y-2 px-6 lg:px-0">
                    <div className="w-full items-center">
                      <div className="text-lg py-3 w-full font-semibold text-[#00E0FF]">
                        Driver&nbsp;Details
                      </div>
                      <div className="flex lg:space-x-0 items-center py-2 rounded-full">
                        <div className="text-white font-semibold text-sm md:text-base w-32 sm:w-32 md:w-40 lg:w-40">
                          Assign&nbsp;driver
                        </div>
                        <Select
                          className="w-32 bg-white border border-slate-300 rounded-lg focus:outline-none focus:border-none"
                          options={driversForAssign.map((driver) => {
                            return {
                              value: driver,
                              label: driver?.name,
                            };
                          })}
                          onChange={(e) => {
                            setdriverid(e.value?._id);
                          }}
                        />
                        <div
                          onClick={() => {
                            dispatch({
                              type: "ASSIGN_DRIVER",
                              payload: {
                                body: {
                                  bookingId: id,
                                  driverId: driverid,
                                },
                                token: token,
                              },
                            });
                          }}
                          className="text-base font-semibold text-teal-500 px-2 py-0.5 rounded-sm cursor-pointer"
                        >
                          Save
                        </div>
                      </div>
                    </div>
                    {bookingDetails?.driverDetails ? (
                      <div className="pt-2 space-y-2">
                        <BookingDetailsItem
                          label="Driver Name"
                          value={bookingDetails?.driverDetails?.name}
                        />
                        <BookingDetailsItem
                          label="Contact Number"
                          value={
                            bookingDetails?.driverDetails?.countryCode &&
                            bookingDetails?.driverDetails?.contactNumber &&
                            bookingDetails?.driverDetails?.countryCode +
                              " " +
                              bookingDetails?.driverDetails?.contactNumber
                          }
                        />
                        <BookingDetailsItem
                          label="Car Plate Number"
                          value={
                            bookingDetails?.driverDetails?.carPlateNo
                              ? bookingDetails?.driverDetails?.carPlateNo
                              : "--"
                          }
                        />
                        <BookingDetailsItem
                          label="License Number"
                          value={
                            bookingDetails?.driverDetails?.carLicenseNo
                              ? bookingDetails?.driverDetails?.carLicenseNo
                              : "--"
                          }
                        />
                      </div>
                    ) : (
                      <div className="pt-2 space-y-2"></div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;

export const BookingDetailsItem = ({ label, value }) => {
  return (
    <>
      <div className="flex items-center">
        <div className="text-white font-semibold text-sm md:text-base w-32 md:w-40">
          {label}:
        </div>
        {!value ? (
          <div
            role="status"
            class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center"
          >
            <div class="h-2.5 bg-gray-400 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
          </div>
        ) : (
          <div className="text-gray-300 font-normal text-base w-auto">
            {value}
          </div>
        )}
      </div>
    </>
  );
};
